import { Breakpoint } from '../hooks/useBreakpoint/index.types';
import { BreakpointProp } from '../types/styles';

export const isBreakpointObject = <T>(prop: BreakpointProp<T>) => {
  const isObject = prop && typeof prop === 'object';

  return (
    isObject &&
    Breakpoint.MOBILE in prop &&
    Breakpoint.TABLET in prop &&
    Breakpoint.DESKTOP in prop
  );
};
